import React from 'react';

export const capitalize = string =>
  string && string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeAll = string =>
  string &&
  string
    .split(" ")
    .map(word => (word.length > 1 ? capitalize(word) : word))
    .join(" ");

export const camelCaseToTitle = string =>
  (string && typeof string === 'string') ? string.split(/(?=[A-Z])/).map(word => capitalize(word)).join(' ') : string

export const snakeCaseToTitleCase = (s) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())

export const titleToCamelCase = str => str
  .replace(/\s(.)/g, function (a) {
    return a.toUpperCase();
  })
  .replace(/\s/g, '')
  .replace(/^(.)/, function (b) {
    return b.toLowerCase();
  });

export const findOptions = (value, options = []) => {
  if (value instanceof Array) {
    return value.map(v => {
      const op = options.find(o => o.value === v);
      return op ? op.label : v;
    });
  }
  if (typeof value === "string") {
    const op = options.find(o => o.value === value);
    return op ? op.label : value;
  }
  return value;
}
export const getOptionAsObject = (value, options) => {
  if (value instanceof Array) {
    return value.map(v => {
      const op = options.find(o => o.value === v);
      return op || { label: v, value: v };
    });
  }
  if (typeof value === "string") {
    const op = options.find(o => o.value === value);
    return op || { value, label: value };
  }
  return value;
}

export const isEmptyOrSpaces = (str) => typeof str === 'string' ?
  str === null || str.match(/^ *$/) !== null : true;

export function getSourceString(author, item) {
  return item.children ?
    <span
      className="ant-btn-link"
      style={{ cursor: "pointer" }}
      onClick={() => {
        const iconOne = document.querySelector(`.show-row-${item.id}`);
        const iconTwo = document.querySelector(`.hide-row-${item.id}`);
        if (iconOne) {
          iconOne.click();
        } else if (iconTwo) {
          iconTwo.click();
        }
      }}> {`${item.sourcesLen} Source${item.sourcesLen > 1 ? "(s)" : ""}`} </span> : author;
}

export const getDivergenceOrEqual = (data, keys) => {
  if (data.children && Array.isArray(data.children) && data.children.length) {
    keys.forEach(key => {
      const firstValue = data[key];
      const areSameData = data.children.every(i => i[key] === firstValue);
      if (!areSameData) {
        data[key] = <span className="ant-typography ant-typography-danger">Divergence</span>;
      }
    });
  }
  return data
}

export const selectFilterSearch = (input = '', option = {}) => {
  if (option) {
    const { children } = option;
    const str = Array.isArray(children) ? children.join('') : typeof children === 'string' ? children : '';
    const lowerCase = typeof str === 'string' ? str.toLocaleLowerCase() : '';
    return lowerCase.indexOf(input.toLowerCase()) !== -1;
  }
  return false;
};

export const nowToIso = () => {
  const date = new Date();
  return date.toISOString();
};
